module.exports = __webpack_public_path__ + "static/media/deine-buga__image--upload-foto.acbd7e26.svg";